import React, { useRef } from 'react';
import { Atom } from 'AppReact';
import { MentionsInput, Mention } from 'react-mentions'
import defaultStyle from './defaultStyle';
import defaultStyleBottom from './defaultStyleBottom';
import defaultMentionStyle from './defaultMentionStyle';

const MentionInput = ({ personsToMention, inputVal, placeholder, onChange, displayBottom }) => {

  const handleChange = (_event, newValue, newPlainTextValue, mentions) => {
    onChange({ action: 'change', value: newValue, mentioned: mentions.map(m => Number(m.id)) })
  };

  const onKeyPress = (event) => {
    if (event.key === 'Enter') {
      onChange({ action: 'submit' })
    }
  }

  const inputRef = useRef(null);

  return (
    <MentionsInput
      singleLine
      onKeyDown={onKeyPress}
      inputRef={inputRef}
      value={inputVal}
      onChange={handleChange}
      style={displayBottom ? defaultStyleBottom : defaultStyle}
      placeholder={placeholder}
    >
      <Mention
        trigger='@'
        data={personsToMention.map(p => ({ id: p.id, display: p.name }))}
        style={defaultMentionStyle}
      />
    </MentionsInput>
  )
}

export default Atom({ type: 'custom', dataType: 'string', template: MentionInput });
